// extracted by mini-css-extract-plugin
module.exports = {"Message":"Message_Message__3xodG","Icon":"Message_Icon__3Xo1K","Content":"Message_Content__BvASB","Target":"Message_Target__RX_au"};